export const gitCommit = '5a6940c0'
